import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import PhotoViewerDialog from './PhotoViewerDialog';

const PhotoBrowser = (props) => {
   const [openPhoto, setOpenPhoto] = useState({isOpen: false, photo: null});

   const handleClickPhoto = (photo) => {
      if(typeof props.selectPhoto === 'function')
         props.selectPhoto(photo.id);
      else {
         setOpenPhoto({isOpen: true, photo: photo});
      }
   };

   const handleClose = () => {
      setOpenPhoto({isOpen: false, photo: openPhoto.photo});
   };

   return (
      <Fragment>
         <Grid item xs={12}>
            {props.photos.length === 0 ? <Alert severity="info">{props.emptyMessage ? props.emptyMessage : 'No photos to display'}</Alert> : <ImageList
               sx={{ width: 'auto', maxHeight: "30em", padding: 1}} cols={3}>
                  {props.photos.map((photo) => (
                     <ImageListItem key={photo.id} sx={{ cursor: 'pointer', border: photo.selected ? '3px solid #00a5de' : 'none' }}>
                        <img
                           src={photo.base64PhotoScaled}
                           srcSet={photo.base64PhotoScaled}
                           alt={photo.caption}
                           loading="lazy"
                           onClick={()=>{handleClickPhoto(photo)}}
                        />
                     </ImageListItem>
                  ))}
            </ImageList>}
         </Grid>
         <PhotoViewerDialog
            open={openPhoto.isOpen}
            onClose={handleClose}
            photos={props.photos}
            selectedPhotoIndex={props.photos.indexOf(openPhoto.photo)}
         />
      </Fragment>
   );
};

PhotoBrowser.propTypes = {
   photos: PropTypes.arrayOf(PropTypes.object),
   emptyMessage: PropTypes.string,
   selectPhoto: PropTypes.func,
};

export default PhotoBrowser;